import Axios from "axios";

export const SelectReleveClient = (z ,f, g, a, b, c, d, e) => {
  return (dispatch) => {
    Axios.get(
      `https://www.24-crm.tn/webservice/api/ReleveClient?codeclient=${z}&vendeur=${f}&grp=${g}&coddos=${a}&serveur=${b}&user=${c}&pwd=${d}&database=${e}`
    ).then((response) => {
      return dispatch({ type: "RELEVERCLIENT_GET", payload: response.data });
    });
  };
};
